export const AppSettings = {
  apiUrl:	  '/api',
  securityApiUrl: '/securityapi',

  myTokenKey: 'ProximaSrlAPI',
  myEmail: 'Email',
  myTokenExpirationDate: 'TokenExpirationDate',
  salt: "$2a$10$LSyz0T20240801JoKerGPT",

  TokenUpdater: {
    checkingFrequencyMilliseconds: 1000 * 60 * 30, // 30 minutes
    refreshThresholdMilliseconds: 1000 * 60 * 45 // If token expires within the next 45 minutes, it's time to refresh it
  },

  "DeviceSettings": {
    "GetDevicesRefreshRateInSeconds": 5,
    "LockButtonDebounceInSeconds": 10,
    "ExecuteCommand": {
      "OutputPort": 1,
      "Source": "glv-web",
      "AutomaticPulseDurationInseconds": 10
    }
  }
  
};
